import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxActivityTaskSessionsComponent } from '@go-modules/components/activity-task-sessions/activity-task-sessions.component';

export const ngxActivityTaskSessionsModule = angular.module('ngxActivityTaskSessionsModule', [])
	.directive('ngxActivityTaskSessions', downgradeComponent({ component: NgxActivityTaskSessionsComponent }))
	.name;
